export default __webpack_public_path__ + "static/SourceSansPro-SemiBold-43cc81b496222dc9ce3ce7d6970a95a6.ttf";